import { inject } from '@angular/core';
import {
  EOrderOrigin,
  IPaymentProvider,
  PaymentMethod,
  PAYMENT_PROVIDERS_SCHEMA,
  UserDto,
  IConfiguredDirectTicket,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../app-config.service';
import { IListGateway } from '../gateways';

export class PaymentProviderGateway implements IListGateway<
  null,
  IApiResponse<IPaymentProvider[]>
> {
  private readonly configService: AppConfigService = inject(AppConfigService);
  readonly paymentProviderUrl: string =
    this.configService.get().general.paymentUrl;
  private readonly restCallBuilder: RestCallBuilder<any> =
    new RestCallBuilder<any>([]);

  list(): Observable<IApiResponse<IPaymentProvider[]>> {
    return this.restCallBuilder
      .get('/paymentProviders/')
      .validate(
        API_RESPONSE_SCHEMA(PAYMENT_PROVIDERS_SCHEMA),
        'PaymentProvider.list'
      )
      .handleMessages()
      .build();
  }

  buy() {
    return this.restCallBuilder
      .postExternal(`${this.paymentProviderUrl}/logpay/buy`, undefined)
      .handleMessages()
      .build();
  }

  getPaymentMethods(): Observable<IApiResponse<PaymentMethod[]>> {
    return this.restCallBuilder
      .getExternal(`${this.paymentProviderUrl}/logpay/payment-methods`)
      .handleMessages()
      .build();
  }

  addPaymentMethods(
    origin: EOrderOrigin,
    userData?: UserDto,
    products: IConfiguredDirectTicket[] = [],
    orderId: string | undefined = undefined
  ) {
    return this.restCallBuilder
      .postExternal(
        `${this.paymentProviderUrl}/logpay/${origin}/payment-methods`,
        { userData, products, orderId }
      )
      .handleMessages()
      .build();
  }

  addGuestPaymentMethods(
    customerId: string,
    origin: EOrderOrigin,
    products: IConfiguredDirectTicket[] = [],
    orderId: string | undefined = undefined
  ) {
    return this.restCallBuilder
      .postExternal(
        `${this.paymentProviderUrl}/logpay/${customerId}/${origin}/payment-methods/guest`,
        { products, orderId }
      )
      .handleMessages()
      .build();
  }

  deletePaymentMethods(paymentMethodId: string) {
    return this.restCallBuilder
      .deleteExternal(
        `${this.paymentProviderUrl}/logpay/payment-methods/${paymentMethodId}`
      )
      .handleMessages()
      .build();
  }
}
